// extracted by mini-css-extract-plugin
module.exports = {"container":"KakoPromotionBanner_container__6UMu6","badge":"KakoPromotionBanner_badge__U_J2n","content":"KakoPromotionBanner_content__BhiHK"};